module.exports = __webpack_public_path__ + "img/227.5af02349.png";